import { convertToFormatedDateString } from '../../../../../services/util/date.service'
import { somenteDigitos } from '../../../../../services/util/documento.service'
import { validarParte } from '../Partes/ctePartes.util'
import {
  VALORES_FISCAIS_INICIAIS,
  erroValoresFiscais,
  toNum,
} from '../ValoresFiscaisCte/valoresFiscaisCte.util'

// Regras do CTe de Substituição (Ajuste SINIEF 09/07, cláusulas 17 e 17-A), espelho das validações do backend

export const MOTIVO_SUBSTITUICAO_MIN = 15
export const MOTIVO_SUBSTITUICAO_MAX = 255
// Motivo previsto na cláusula 17-A para a troca de tomador
export const MOTIVO_TROCA_TOMADOR = 'tomador informado erroneamente'
export const LIMITE_OBSERVACAO = 2000
// Portal onde o tomador registra o evento de Prestação do Serviço em Desacordo (vale para qualquer UF)
export const URL_PORTAL_DESACORDO =
  'https://dfe-portal.svrs.rs.gov.br/CTE/PrestacaoServicoDesacordo'
export const TOMADOR_OUTROS = 'outros'
export const AVISO_TOMADOR_OUTROS =
  'O tomador do serviço do CT-e de substituição poderá ser um estabelecimento diferente dos envolvidos no CT-e original, desde que pertencente a alguma das empresas originalmente consignadas como remetente, destinatário, tomador, expedidor ou recebedor no CT-e original, e desde que localizado na mesma unidade federada do tomador original.'

export const isCteDeSubcontratacao = cte => cte.document_origin === 'cte'

// CTes com notas anteriores à escolha do tomador não têm o campo gravado e valem Remetente
export function tomadorDoCte(cte) {
  if (isCteDeSubcontratacao(cte)) return '4'
  return cte.tomador || '0'
}

export function nomeTomador(cte, partes) {
  const tomador = tomadorDoCte(cte)
  if (tomador === '4') return partes && partes.outros ? partes.outros.nome : cte.cte_origem_emitente
  if (tomador === '1') return partes && partes.expedidor ? partes.expedidor.nome : 'Expedidor'
  if (tomador === '2') return partes && partes.recebedor ? partes.recebedor.nome : 'Recebedor'
  return tomador === '3' ? cte.client_name : cte.company_name
}

export function descreverTomador(cte, partes, tomador = tomadorDoCte(cte), tomadorOutros = null) {
  const p = partes || {}
  if (tomador === TOMADOR_OUTROS) {
    const preenchido = tomadorOutros && String(tomadorOutros.nome || '').trim()
    return {
      papel: 'Outros',
      parte: preenchido ? { nome: tomadorOutros.nome, cnpj_cpf: tomadorOutros.cnpj_cpf } : null,
    }
  }
  if (tomador === '4') {
    return p.outros
      ? { papel: 'Outros', parte: p.outros }
      : { papel: 'Contratante', parte: p.contratante || null }
  }
  if (tomador === '3') return { papel: 'Destinatário', parte: p.destinatario || null }
  if (tomador === '1') return { papel: 'Expedidor', parte: p.expedidor || null }
  if (tomador === '2') return { papel: 'Recebedor', parte: p.recebedor || null }
  return { papel: 'Remetente', parte: p.remetente || null }
}

export function opcoesTomador(cte, partes) {
  const p = partes || {}
  const tomadores = isCteDeSubcontratacao(cte)
    ? []
    : cte.globalizado
      ? ['0']
      : ['0', ...(p.expedidor ? ['1'] : []), ...(p.recebedor ? ['2'] : []), '3']
  if (tomadorDoCte(cte) === '4') tomadores.push('4')
  const atuais = tomadores.map(tomador => {
    const descricao = descreverTomador(cte, partes, tomador)
    const outrosAtual = tomador === '4' && partes && partes.outros
    return { value: tomador, ...descricao, papel: outrosAtual ? 'Outros (atual)' : descricao.papel }
  })
  return [...atuais, { value: TOMADOR_OUTROS, papel: 'Outros', parte: null }]
}

export const exigeTelefoneContratante = (cte, partes, tomador) =>
  isCteDeSubcontratacao(cte) && tomador === '4' && !(partes && partes.outros)

// Valores e impostos do CTe a substituir, como ponto de partida da correção
export function estadoInicialSubstituicao(cte) {
  const state = { observacoes: '' }
  Object.keys(VALORES_FISCAIS_INICIAIS).forEach(campo => {
    const texto = /situacao_tributaria|classificacao_tributaria/.test(campo)
    state[campo] = texto ? cte[campo] || null : toNum(cte[campo])
  })
  return state
}

// Expressão exigida nas observações do CTe substituto, montada pelo backend com o motivo informado
export function expressaoLegal(cte, motivo) {
  const texto = String(motivo || '')
    .trim()
    .replace(/\.+$/, '')
  return `Este documento substitui o CT-e nº ${cte.numero} série ${cte.serie} de ${convertToFormatedDateString(
    cte.data_emissao,
  )} em virtude de ${texto || '(motivo)'}.`
}

// Primeira inconsistência do formulário, ou null
export function erroSubstituicao({
  cte,
  partes,
  state,
  motivo,
  tomador,
  tomadorOutros,
  telefoneTomador,
}) {
  const motivoLimpo = String(motivo || '').trim()
  if (
    motivoLimpo.length < MOTIVO_SUBSTITUICAO_MIN ||
    motivoLimpo.length > MOTIVO_SUBSTITUICAO_MAX
  ) {
    return `Informe o Motivo da substituição (entre ${MOTIVO_SUBSTITUICAO_MIN} e ${MOTIVO_SUBSTITUICAO_MAX} caracteres)`
  }

  if (exigeTelefoneContratante(cte, partes, tomador)) {
    const telefone = somenteDigitos(telefoneTomador)
    if (telefone.length < 6 || telefone.length > 14) {
      return 'Informe o Telefone do Tomador (emitente do CTe de origem) com 6 a 14 dígitos'
    }
  }

  if (tomador === TOMADOR_OUTROS) {
    if (tomadorOutros.tipo_pessoa !== 'PJ') return 'Tomador Outros: informe um CNPJ'
    const erroParte = validarParte(tomadorOutros, 'Tomador Outros')
    if (erroParte) return erroParte
    const telefone = somenteDigitos(tomadorOutros.telefone)
    if (telefone.length < 6 || telefone.length > 14) {
      return 'Tomador Outros: informe o telefone com 6 a 14 dígitos'
    }
  }

  const erroFiscal = erroValoresFiscais(state)
  if (erroFiscal) return erroFiscal

  if (state.observacoes && state.observacoes.length > LIMITE_OBSERVACAO) {
    return `O campo Observações deve ter no máximo ${LIMITE_OBSERVACAO} caracteres`
  }
  return null
}

// O que muda do CTe original para o substituto, para a confirmação: [{ rotulo, antes, depois, moeda, tomador }]
export function resumoAlteracoes(cte, partes, state, tomador, tomadorOutros) {
  const alteracoes = []
  if (tomador !== tomadorDoCte(cte)) {
    alteracoes.push({
      rotulo: 'Tomador',
      antes: descreverTomador(cte, partes),
      depois: descreverTomador(cte, partes, tomador, tomadorOutros),
      tomador: true,
    })
  }
  const valores = [
    { rotulo: 'Valor Bruto Frete', campo: 'valor_total' },
    { rotulo: 'Valor Líquido Frete', campo: 'valor_receber' },
    { rotulo: 'Valor ICMS', campo: 'icms_valor' },
  ]
  valores.forEach(({ rotulo, campo }) => {
    const antes = toNum(cte[campo])
    const depois = toNum(state[campo])
    if (antes !== depois) alteracoes.push({ rotulo, antes, depois, moeda: true })
  })
  return alteracoes
}

// Para valor cobrado a menor o instrumento é o CTe Complementar (cláusula 17, § 3º)
export const valorMaiorQueOriginal = (cte, state) =>
  toNum(state.valor_total) > toNum(cte.valor_total)

// Datas de GET /cte/substituicao/dados chegam no horário local (AAAA-MM-DDTHH:mm:ss)
export const prazoVencido = limite => Boolean(limite) && new Date(limite).getTime() < Date.now()
